import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	fetchedPicklists: [],
};

const picklistsSlice = createSlice({
	name: 'picklists',
	initialState: initialState,
	reducers: {
		setPicklists: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setPicklists, reset } = picklistsSlice.actions;

export default picklistsSlice.reducer;